import { render } from "./NewLogin.vue?vue&type=template&id=6146e775&scoped=true"
import script from "./NewLogin.vue?vue&type=script&scoped=true&lang=js"
export * from "./NewLogin.vue?vue&type=script&scoped=true&lang=js"

import "./NewLogin.vue?vue&type=style&index=0&id=6146e775&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6146e775"]])

export default __exports__